/* eslint-disable @typescript-eslint/no-explicit-any */
import { defaultValues } from "../../data/constants/demanderRDV";
import { IError } from "../../data/types/interface/demanderRDV";
import { MAIL_VALIDATION, MESSAGE_VALIDATION, PHONE_NUMBER_VALIDATION } from "./validation";

export const Validation = (values: IError, listAgence?: []) => {
  let errors: IError = {...defaultValues};

  if (!MAIL_VALIDATION.test(values.mail)) {
    errors.mail = MESSAGE_VALIDATION.requiredEmail;
  }

  /** agence cheking */
  if (values.agence !== '') {
    const _list = listAgence && [...listAgence];
    const _data =
      _list &&
      _list.filter(
        (item: any) =>
          item.label.toLowerCase().indexOf(values.agence.toLowerCase()) > -1,
      );
    const _agence =
      _list && _list.filter((item: any) => item.label === values.agence);

    if ((_data && _data.length === 0) || _agence?.length === 0) {
      errors.agence = MESSAGE_VALIDATION.requiredAgence;
    }
  }

  /** telphone cheking */
  if (!PHONE_NUMBER_VALIDATION.test(values.telephone)) {
    errors.telephone = MESSAGE_VALIDATION.requiredTelephone;
  }

  /** checking all values */
  Object.entries(values).forEach(element => {
    if (element[1] === '' || element[1] === null) {
      errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
    }
  });

  return errors;
};
